import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 查询玩家列表
const playerList = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_player_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家列表
const playerDetail = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_player_detail + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家怪兽
const findMonstersByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_monster_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家皮肤
const findSkinsByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_skin_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家元核
const findEmblemsByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_emblems_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家阵容
const findLineupsByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_lineups_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家战纹
const findWarGroovesByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_war_grooves_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家道具
const findPropsByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_props_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 查询玩家主城
const findMainCityByPlayerId = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_main_city_find + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 玩家充值查询
const findCharges = obj => new Promise((resolve, reject) => {
    const {
        iapFindBO,
        token
    } = obj
    request({
        url: apis.game_charges_find + '?token=' + token,
        data: iapFindBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家邮件查询
const findMails = obj => new Promise((resolve, reject) => {
    const {
        mailFindBO,
        token
    } = obj
    request({
        url: apis.game_mail_find + '?token=' + token,
        data: mailFindBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家邮件删除
const delMail = obj => new Promise((resolve, reject) => {
    const {
        mailDelBO,
        token
    } = obj
    request({
        url: apis.game_mail_del + '?token=' + token,
        data: mailDelBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家聊天查询
const findChatLogs = obj => new Promise((resolve, reject) => {
    const {
        chatFindBO,
        token
    } = obj
    request({
        url: apis.game_chat_log_find + '?token=' + token,
        data: chatFindBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家聊天删除
const delChatLog = obj => new Promise((resolve, reject) => {
    const {
        chatDelBO,
        token
    } = obj
    request({
        url: apis.game_chat_log_del + '?token=' + token,
        data: chatDelBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家留言查询
const findMixedMessages = obj => new Promise((resolve, reject) => {
    const {
        msgFindBO,
        token
    } = obj
    request({
        url: apis.game_mixed_msg_find + '?token=' + token,
        data: msgFindBO
    }).then(res => {
        resolve(res);
    })
})

// 玩家留言删除
const delMixedMessage = obj => new Promise((resolve, reject) => {
    const {
        msgDelBO,
        token
    } = obj
    request({
        url: apis.game_mixed_msg_del + '?token=' + token,
        data: msgDelBO
    }).then(res => {
        resolve(res);
    })
})

// 封停账号
const blockRole = obj => new Promise((resolve, reject) => {
    const {
        blockRoleBO,
        token
    } = obj
    request({
        url: apis.game_block_role + '?token=' + token,
        data: blockRoleBO
    }).then(res => {
        resolve(res);
    })
})

// 禁言账号
const forbidSpeak = obj => new Promise((resolve, reject) => {
    const {
        forbidSpeakBO,
        token
    } = obj
    request({
        url: apis.game_forbid_speak + '?token=' + token,
        data: forbidSpeakBO
    }).then(res => {
        resolve(res);
    })
})

// 伪禁言账号
const fakeForbidSpeak = obj => new Promise((resolve, reject) => {
    const {
        fakeForbidSpeakBO,
        token
    } = obj
    request({
        url: apis.game_fake_forbid_speak + '?token=' + token,
        data: fakeForbidSpeakBO
    }).then(res => {
        resolve(res);
    })
})

// 解除封禁
const unblockRole = obj => new Promise((resolve, reject) => {
    const {
        unblockRoleBO,
        token
    } = obj
    request({
        url: apis.game_unblock_role + '?token=' + token,
        data: unblockRoleBO
    }).then(res => {
        resolve(res);
    })
})

// 解除禁言
const allowSpeak = obj => new Promise((resolve, reject) => {
    const {
        allowSpeakBO,
        token
    } = obj
    request({
        url: apis.game_allow_speak + '?token=' + token,
        data: allowSpeakBO
    }).then(res => {
        resolve(res);
    })
})

// 改名
const playerRename = obj => new Promise((resolve, reject) => {
    const {
        renameBO,
        token
    } = obj
    request({
        url: apis.game_player_rename + '?token=' + token,
        data: renameBO
    }).then(res => {
        resolve(res);
    })
})

// 解除关联
const playerDisconnect = obj => new Promise((resolve, reject) => {
    const {
        disconnectBO,
        token
    } = obj
    request({
        url: apis.game_player_disconnect + '?token=' + token,
        data: disconnectBO
    }).then(res => {
        resolve(res);
    })
})

// 部落查询
const findTribes = obj => new Promise((resolve, reject) => {
    const {
        tribeQueryBO,
        token
    } = obj
    request({
        url: apis.game_tribe_find + '?token=' + token,
        data: tribeQueryBO
    }).then(res => {
        resolve(res);
    })
})

// 屏蔽玩家信息
const playerInfoShield = obj => new Promise((resolve, reject) => {
    const {
        infoShieldBO,
        token
    } = obj
    request({
        url: apis.game_player_info_shield + '?token=' + token,
        data: infoShieldBO
    }).then(res => {
        resolve(res);
    })
})


// 游戏服重载
const gameReloadAll = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.game_reload_all + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

// 游戏服全部重载
const gameReloadConfig = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.game_reload_config + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

// 修改时间
const changeTime = obj => new Promise((resolve, reject) => {
    const {
        timeForm,
        token
    } = obj
    request({
        url: apis.game_change_time + '?token=' + token,
        data: timeForm
    }).then(res => {
        resolve(res);
    })
})

// 发道具
const sendItem = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_send_item + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 解锁怪兽
const unlockMonster = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_unlock_monster + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

const lvMonster = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_lv_monster + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 解锁地图
const unlockMap = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_unlock_map + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 解锁怪兽
const changeWarStatus = obj => new Promise((resolve, reject) => {
    const {
        warChangeForm,
        token
    } = obj
    request({
        url: apis.game_change_war_status + '?token=' + token,
        data: warChangeForm
    }).then(res => {
        resolve(res);
    })
})

const triggerRandomEvent = obj => new Promise((resolve, reject) => {
    const {
        randomEventForm,
        token
    } = obj
    request({
        url: apis.game_trigger_random_event + '?token=' + token,
        data: randomEventForm
    }).then(res => {
        resolve(res);
    })
})

const updateUserType = obj => new Promise((resolve, reject) => {
    const {
        updateForm,
        token
    } = obj
    request({
        url: apis.game_update_user_task + '?token=' + token,
        data: updateForm
    }).then(res => {
        resolve(res);
    })
})

// 清理古战役排阵信息
const clearAncientCampaign = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_clear_ancient_campaign + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 全通部落冒险
const passTribeAdventures = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_pass_tribe_adventures + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 填充部落
const fillTribe = obj => new Promise((resolve, reject) => {
    const {
        playerQueryForm,
        token
    } = obj
    request({
        url: apis.game_fill_tribe + '?token=' + token,
        data: playerQueryForm
    }).then(res => {
        resolve(res);
    })
})

// 清除部落昵称
const rewriteTribeName = obj => new Promise((resolve, reject) => {
    const {
        clearTribeBO,
        token
    } = obj
    request({
        url: apis.game_rewrite_tribe_name + '?token=' + token,
        data: clearTribeBO
    }).then(res => {
        resolve(res);
    })
})

// 清除部落公告
const rewriteTribeBulletin = obj => new Promise((resolve, reject) => {
    const {
        clearTribeBO,
        token
    } = obj
    request({
        url: apis.game_rewrite_tribe_Bulletin + '?token=' + token,
        data: clearTribeBO
    }).then(res => {
        resolve(res);
    })
})

// 高级账号生成
const buildAccount = obj => new Promise((resolve, reject) => {
    const {
        buildAccountBO,
        token
    } = obj
    request({
        url: apis.game_build_account + '?token=' + token,
        data: buildAccountBO
    }).then(res => {
        resolve(res);
    })
})

const getTableName = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.game_get_table_name + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

const clearSettingCache = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.game_cache_clear_setting + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

const getCacheValue = obj => new Promise((resolve, reject) => {
    const {
        cacheKitForm,
        token
    } = obj;
    request({
        url: apis.game_cache_val + '?token=' + token,
        data:cacheKitForm
    }).then(res => {
        resolve(res);
    })
});

const loginQueueOperation = obj => new Promise((resolve, reject) => {
    const {
        operationForm,
        token
    } = obj;
    request({
        url: apis.game_queue_operation + '?token=' + token,
        data:operationForm
    }).then(res => {
        resolve(res);
    })
});

const repushOrder = obj => new Promise((resolve, reject) => {
    const {
        repushForm,
        token
    } = obj;
    request({
        url: apis.game_repush_order + '?token=' + token,
        data:repushForm
    }).then(res => {
        resolve(res);
    })
})

const rankingInfo = obj => new Promise((resolve, reject) => {
    const {
        rankingForm,
        token
    } = obj;
    request({
        url: apis.game_ranking_info + '?token=' + token,
        data:rankingForm
    }).then(res => {
        resolve(res);
    })
})

const clearRanking = obj => new Promise((resolve, reject) => {
    const {
        rankingForm,
        token
    } = obj;
    request({
        url: apis.game_ranking_clear + '?token=' + token,
        data:rankingForm
    }).then(res => {
        resolve(res);
    })
})



const deductItem = obj => new Promise((resolve, reject) => {
    const {
        deductItemForm,
        token
    } = obj;
    request({
        url: apis.game_deduct_item + '?token=' + token,
        data:deductItemForm
    }).then(res => {
        resolve(res);
    })
})

const dotTipsPush = obj => new Promise((resolve, reject) => {
    const {
        dotPushForm,
        token
    } = obj;
    request({
        url: apis.game_dot_tips + '?token=' + token,
        data:dotPushForm
    }).then(res => {
        resolve(res);
    })
})

// 通过号码获取转移
const findTransferByTel = obj => new Promise((resolve, reject) => {
    const {
        findTransferByTelForm,
        token
    } = obj;
    request({
        url: apis.find_transfer_by_tel + '?token=' + token,
        data:findTransferByTelForm
    }).then(res => {
        resolve(res);
    })
})

// 获取转移玩家
const findPlayersByTransfer = obj => new Promise((resolve, reject) => {
    const {
        findPlayersByTransferForm,
        token
    } = obj;
    request({
        url: apis.find_players_by_transfer + '?token=' + token,
        data:findPlayersByTransferForm
    }).then(res => {
        resolve(res);
    })
})

// 查询岸腾sid的换绑记录
const getRecordByQuickSid = obj => new Promise((resolve, reject) => {
    const {
        quickSid,
        token
    } = obj;
    request({
        url: apis.get_record_by_quick_sid + '?token=' + token + '&quickSid=' + quickSid,
    }).then(res => {
        resolve(res);
    })
})

// 雷霆账号验证开关
const openMsgRecordByQuickSid = obj => new Promise((resolve, reject) => {
    const {
        quickSid,
        token
    } = obj;
    request({
        url: apis.open_msg_record_by_quick_sid + '?token=' + token + '&quickSid=' + quickSid,
    }).then(res => {
        resolve(res);
    })
})

// 刷新验证记录
const getMsgRecordByQuickSid = obj => new Promise((resolve, reject) => {
    const {
        quickSid,
        token
    } = obj;
    request({
        url: apis.get_msg_record_by_quick_sid + '?token=' + token + '&quickSid=' + quickSid,
    }).then(res => {
        resolve(res);
    })
})

// 查询雷霆sid的换绑记录
const getRecordByLeitingSid = obj => new Promise((resolve, reject) => {
    const {
        leitingSid,
        token
    } = obj;
    request({
        url: apis.get_record_by_leiting_sid + '?token=' + token + '&leitingSid=' + leitingSid,
    }).then(res => {
        resolve(res);
    })
})

// 换绑
const submitTransfer = obj => new Promise((resolve, reject) => {
    const {
        submitTransferForm,
        token
    } = obj;
    request({
        url: apis.submit_transfer + '?token=' + token,
        data:submitTransferForm
    }).then(res => {
        resolve(res);
    })
})

// 换绑进度查询
const getAllProgress = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.get_all_progress + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
})

// 换绑进度单个查询
const getProgress = obj => new Promise((resolve, reject) => {
    const {
        progressForm,
        token
    } = obj;
    request({
        url: apis.get_progress + '?token=' + token,
        data:progressForm
    }).then(res => {
        resolve(res);
    })
})

// 待转绑信息查询
const listByFinishValidate = obj => new Promise((resolve, reject) => {
    const {
        submitStatus,
        token
    } = obj;
    request({
        url: apis.list_by_finish_validate + '?token=' + token + '&submitStatus=' + submitStatus,
    }).then(res => {
        resolve(res);
    })
})

// 取消绑定
const cancelBind = obj => new Promise((resolve, reject) => {
    const {
        quickSid,
        token
    } = obj;
    request({
        url: apis.cancel_bind + '?token=' + token + '&quickSid=' + quickSid,
    }).then(res => {
        resolve(res);
    })
})

// 举报查询
const showAllReports = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.show_all_reports + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
})

// 处理举报
const handleReports = obj => new Promise((resolve, reject) => {
    const {
        token,
        id
    } = obj;
    request({
        url: apis.handle_reports + '?token=' + token + '&id=' + id,
    }).then(res => {
        resolve(res);
    })
})

// 举报历史记录
const showHistory = obj => new Promise((resolve, reject) => {
    const {
        token,
        showHistoryForm
    } = obj;
    request({
        url: apis.show_history + '?token=' + token,
        data: showHistoryForm
    }).then(res => {
        resolve(res);
    })
})

export default {
    playerList,
    playerDetail,
    findMonstersByPlayerId,
    findSkinsByPlayerId,
    findEmblemsByPlayerId,
    findLineupsByPlayerId,
    findWarGroovesByPlayerId,
    findPropsByPlayerId,
    findMainCityByPlayerId,
    findCharges,
    findMails,
    delMail,
    findChatLogs,
    delChatLog,
    findMixedMessages,
    delMixedMessage,
    blockRole,
    forbidSpeak,
    fakeForbidSpeak,
    unblockRole,
    allowSpeak,
    playerRename,
    playerDisconnect,
    findTribes,
    playerInfoShield,
    gameReloadAll,
    gameReloadConfig,
    changeTime,
    unlockMap,
    unlockMonster,
    lvMonster,
    sendItem,
    triggerRandomEvent,
    changeWarStatus,
    updateUserType,
    clearAncientCampaign,
    passTribeAdventures,
    fillTribe,
    rewriteTribeName,
    rewriteTribeBulletin,
    buildAccount,
    getTableName,
    clearSettingCache,
    getCacheValue,
    loginQueueOperation,
    repushOrder,
    rankingInfo,
    clearRanking,
    dotTipsPush,
    deductItem,
    findTransferByTel,
    findPlayersByTransfer,
    getRecordByQuickSid,
    openMsgRecordByQuickSid,
    getMsgRecordByQuickSid,
    getRecordByLeitingSid,
    submitTransfer,
    getAllProgress,
    getProgress,
    listByFinishValidate,
    cancelBind,
    showAllReports,
    handleReports,
    showHistory
}



// WEBPACK FOOTER //
// ./src/service/game_api.js